import { EntityPerspective } from '@/common/entityFramework/entityPerspective/EntityPerspective';
import { RowIcon } from '@/common/entityFramework/entityPerspective/support/RowIcon';
import { fas } from '@awesome.me/kit-b4fd369ea4/icons';
import { useRef } from 'react';

export const AbvChbkPymtPerspective = () => {
  const entityPerspectiveRef = useRef();

  const views = [
    {
      name: 'Payments',
      dims: ['PAID_PERIOD', 'CHANNEL', 'PROD', 'EARNED_PERIOD'],
      kpis: ['PYMT_AMT', 'PYMT_ADJ', 'TOTAL_PYMT'],
      numFrozenDims: 1,
      dimToPeriodicities: {
        PAID_PERIOD: ['LIFETIME', 'YEAR', 'QTR', 'MON'],
        EARNED_PERIOD: ['YEAR', 'QTR'],
      },
    },
    {
      name: 'Processing Days',
      dims: ['PAID_PERIOD', 'PROD'],
      kpis: [
        'PYMT_AMT',
        'TOTAL_DAYS',
        'TOTAL_RECORDS',
        'BEFORE90_DAYS_PYMT_AMT',
        'BEFORE90_DAYS_TOTAL_DAYS',
        'BEFORE90_DAYS_TOTAL_RECORDS',
      ],
      numFrozenDims: 1,
      dimToPeriodicities: {
        PAID_PERIOD: ['LIFETIME', 'YEAR', 'QTR', 'MON'],
        EARNED_PERIOD: ['YEAR', 'QTR'],
      },
    },
  ];

  const rowIconsFn = (data) => {
    let rowIcons = [];

    // Closed
    if (data.closed) {
      rowIcons.push(<RowIcon key="closed" icon={fas.faCheckCircle} color="green" toolTip="Period is closed" />);
    }

    return rowIcons;
  };

  const getContextMenuItems = (params) => {
    let contextMenus = entityPerspectiveRef.current.getContextMenuItems(params);

    let pymtSubMenu = [
      {
        name: 'Payment Amounts',
        action: () => entityPerspectiveRef.current.navigateToViewer(params, 'PYMT_AMT', 'Payment Amounts'),
        icon: fas.faListUl,
      },
      {
        name: 'Pivot Payment Amounts',
        action: () => entityPerspectiveRef.current.navigateToPivot(params, 'PYMT_AMT', 'Payment Amounts'),
        icon: fas.faTableColumns,
      },
      {
        name: 'Payment Adjustments',
        action: () => entityPerspectiveRef.current.navigateToViewer(params, 'PYMT_ADJ', 'Payment Adjustments'),
        icon: fas.faListUl,
      },
    ];

    let after90DaysSubMenu = [
      {
        name: 'Payment Amounts',
        action: () =>
          entityPerspectiveRef.current.navigateToViewer(params, 'BEFORE90_DAYS_PYMT_AMT', 'Payment Amounts'),
        icon: fas.faListUl,
      },
      {
        name: 'Pivot Payment Amounts',
        action: () => entityPerspectiveRef.current.navigateToPivot(params, 'BEFORE90_DAYS_PYMT_AMT', 'Payment Amounts'),
        icon: fas.faTableColumns,
      },
    ];

    contextMenus.push(
      {
        name: 'Payment Transaction Details',
        subMenu: pymtSubMenu,
        icon: fas.faListUl,
      },
      {
        name: 'Before 90 Days Transaction Details',
        subMenu: after90DaysSubMenu,
        icon: fas.faListUl,
      },
    );

    return contextMenus;
  };

  return (
    <EntityPerspective
      ref={entityPerspectiveRef}
      views={views}
      rowIconsFn={rowIconsFn}
      gridOptions={{
        getContextMenuItems,
      }}
    />
  );
};
